// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ewln","question":"styles_question__SUv5w","description":"styles_description__3gIKh"};